<template>
  <div>
    <row :gutter="16">
      <i-col span="12">
        <span class="ms-help label">Заказчик</span>
        <i-select
          filterable
          placeholder="Выберите компанию"
          v-model="contract.customer_id"
          @on-select="(value) => onSelect('customer_id', value)"
        >
          <i-option
            v-for="item in filteredCustomers"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</i-option
          >
        </i-select>
      </i-col>
    </row>
    <row :gutter="16" style="margin-top: 16px;">
      <i-col span="12">
        <span class="ms-help label">Исполнитель (де-юре)</span>
        <i-select
          filterable
          placeholder="Выберите компанию"
          v-model="contract.performer_id"
          @on-select="(value) => onSelect('performer_id', value)"
        >
          <i-option
            v-for="item in filteredPerformers"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</i-option
          >
        </i-select>
      </i-col>
      <i-col span="12">
        <span class="ms-help label">Исполнитель (де-факто)</span>
        <i-select
          filterable
          placeholder="Выберите компанию"
          v-model="contract.fact_performer_id"
          @on-select="(value) => onSelect('fact_performer_id', value)"
        >
          <i-option
            v-for="item in filteredPerformers"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</i-option
          >
        </i-select>
      </i-col>
    </row>
  </div>
</template>

<script>
const sortingFn = (a, b) => {
  const first = a.name.toLowerCase()
  const second = b.name.toLowerCase()

  if (first > second) return 1
  if (first < second) return -1
  return 0
}

export default {
  props: ['contract'],
  data () {
    return {
      customers: [],
      performers: []
    }
  },
  computed: {
    filteredCustomers () {
      return this.customers.filter((c) => c.id !== this.contract.performer_id)
    },
    filteredPerformers () {
      return this.performers.filter((p) => p.id !== this.contract.customer_id)
    }
  },
  methods: {
    async getData () {
      try {
        const otherCompanies = await this.$store.dispatch('GET_REQUEST', {
          url: 'page/other_company'
        })
        this.performers = await this.$store.dispatch('GET_REQUEST', {
          url: 'page/own_company'
        })

        this.customers = [...otherCompanies, ...this.performers].sort(
          sortingFn
        )
      } catch (error) {
        console.log(error)
      }
    },
    onSelect (field, value) {
      setTimeout(() => this.$set(this.contract, field, value.value), 0)
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style>
</style>
